import axios from 'axios';
import { storeGetters } from '../../storeGetters.constant';
import { storeAction } from '../../storeActions.constant';
import { getBasicHeaders } from '../../../common/utils/utils';
import { storeMutation } from '../../storeMutations.constant';
import { getAxiosCancelTokenSource } from '../../../app.utils';
import { wrapAction } from '../../../common/utils/actionLifecycle';
import {
    ForumManagement,
    ChapterOfficerManagement,
    ProspectManagement,
    ProspectsReadyToPay,
    unwrapOverallChapterHealth,
    mapWaiver,
} from '../../classes/chapterAdminView/chapterAdminView';
import orderBy from 'lodash/orderBy';

export const chapterAdminDetailsState = {
    forumManagement: [],
    chapterOfficerManagemet: [],
    prospectManagement: [],
    prospectsReadyToPay: [],
    chapterReports: [],
    toggleCATools: false,
    toggleOverallChapterHealth: false,
    overallChapterHealthData: unwrapOverallChapterHealth({}),
    healthScore: '',
    chapterHealthReport: [],
};
export const chapterAdminDetailsMutations = {
    [storeMutation.setChapterAdminForumManagementDetails]: (state, data) => {
        state.forumManagement = [];
        if (data.length !== 0) {
            state.forumManagement = data.map(item => new ForumManagement(item));
            state.forumManagement = orderBy(state.forumManagement, 'status', 'asc');
        }
    },
    [storeMutation.setOverallChapterHealth]: (state, data) => {
        state.overallChapterHealthData = unwrapOverallChapterHealth(data);
        state.healthScore = data ? data.healthScore : '';
    },
    [storeMutation.setChapterOfficerManagemet]: (state, data) => {
        state.chapterOfficerManagemet = [];
        if (data.otherOfficers && data.otherOfficers.length !== 0) {
            state.chapterOfficerManagemet = data.otherOfficers.map(item => new ChapterOfficerManagement(item));
        }
        if (data.primaryOfficers && data.primaryOfficers.length !== 0) {
            state.chapterOfficerManagemet = data.primaryOfficers.map(item => new ChapterOfficerManagement(item));
        }
        state.chapterOfficerManagemet = orderBy(state.chapterOfficerManagemet, 'position', 'asc');
    },
    [storeMutation.toggleCATools]: (state, data) => {
        state.toggleCATools = data;
        state.toggleOverallChapterHealth = false;
    },
    [storeMutation.toggleOverallChapterHealth]: (state, data) => {
        state.toggleOverallChapterHealth = data;
        state.toggleCATools = false;
    },
    [storeMutation.setChapterAdminProspectManagement]: (state, data) => {
        state.prospectManagement = [];
        if (data.length !== 0) {
            state.prospectManagement = data.map(item => new ProspectManagement(item));
            state.prospectManagement = orderBy(state.prospectManagement, 'name', 'asc');
            state.prospectManagement.forEach((prospect) => {
                prospect.waiverStatus = mapWaiver(prospect.waiverStatus);
            });
        }
    },
    [storeMutation.setchapterAdminProspectsReadyToPay]: (state, data) => {
        state.prospectsReadyToPay = [];
        if (data.length !== 0) {
            state.prospectsReadyToPay = data.map(item => new ProspectsReadyToPay(item));
            state.prospectsReadyToPay = orderBy(state.prospectsReadyToPay, 'name', 'asc');
        }
    },
    [storeMutation.setChapterHealthReport]: (state, data) => {
        state.chapterHealthReport = data;       
    },
};
export const chapterAdminDetailsActions = {
    [storeAction.getChapterAdminForumManagementDetails]: wrapAction(
        storeAction.getChapterAdminForumManagementDetails,
        async ({ state, commit }, communityId) => {
            return axios({
                url: `${state.baseURL}communities/api/v2/chapter-admin/forum-management/${communityId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setChapterAdminForumManagementDetails, response.data);
                    return true;
                })
                .catch((err) => {
                    commit(storeMutation.setChapterAdminForumManagementDetails, []);
                    throw err;
                });
        },
    ),
    [storeAction.getChapterOfficerManagemet]: wrapAction(
        storeAction.getChapterOfficerManagemet,
        async ({ state, commit }, communityId) => {
            return axios({
                url: `${state.baseURL}communities/api/chapterOfficersList/${communityId}/chapter`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setChapterOfficerManagemet, response.data);
                    return true;
                })
                .catch((err) => {
                    commit(storeMutation.setChapterOfficerManagemet, []);
                    throw err;
                });
        },
    ),
    [storeAction.getChapterAdminProspectManagement]: wrapAction(
        storeAction.getChapterAdminProspectManagement,
        async ({ state, commit }, communityId) => {
            return axios({
                //url: '/mocks/ProspectManagement.json',
                url: `${state.baseURL}communities/api/chapter-admin/prospect-management/${communityId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setChapterAdminProspectManagement, response.data);
                    return true;
                })
                .catch((err) => {
                    commit(storeMutation.setChapterAdminProspectManagement, []);
                    throw err;
                });
        },
    ),
    [storeAction.getChapterAdminProspectsReadyToPay]: wrapAction(
        storeAction.getChapterAdminProspectsReadyToPay,
        async ({ state, commit }, communityId) => {
            return axios({
                url: `${state.baseURL}communities/api/chapter-admin/prospect-ready-to-pay/${communityId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setchapterAdminProspectsReadyToPay, response.data);
                    return true;
                })
                .catch((err) => {
                    commit(storeMutation.setchapterAdminProspectsReadyToPay, []);
                    throw err;
                });
        },
    ),
    [storeAction.getQ2ReportUpdateSalesforceLink]: wrapAction(
        storeAction.getQ2ReportUpdateSalesforceLink,
        async ({ state, commit }, communityId) => {
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getQ2ReportUpdateSalesforceLink,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

            return axios({
                url: `${state.baseURL}communities/api/chapter-admin/chapterHealthRecord/${communityId}`,
                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getQ2ReportUpdateSalesforceLink, {
                        root: true,
                    });
                    commit(storeMutation.setOverallChapterHealth, response.data);
                    return response.data.salesForceId;
                })
                .catch((err) => {
                    throw err;
                });
        },
    ),
    [storeAction.getChapterAdminSFReports]: wrapAction(
        storeAction.getChapterAdminSFReports,
        async ({ state, commit }, communityId) => {
            return axios({
                url: `${state.baseURL}communities/api/chapter-admin/chapterAdminViewSfReports/${communityId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setChapterHealthReport, response.data);
                    return response.data;
                })
                .catch((err) => {
                    throw err;
                });
        },
    ),
};
export const chapterAdminDetailsGetters = {
    [storeGetters.chapterAdminForumManagement]: state => state.forumManagement,
    [storeGetters.chapterOfficerManagemet]: state => state.chapterOfficerManagemet,
    [storeGetters.chapterAdminProspectManagement]: state => state.prospectManagement,
    [storeGetters.chapterAdminProspectsReadyToPay]: state => state.prospectsReadyToPay,
    [storeGetters.getCATools]: state => state.toggleCATools,
    [storeGetters.getOverallChapterHealth]: state => state.toggleOverallChapterHealth,
    [storeGetters.getOverallChapterHealthData]: state => state.overallChapterHealthData,
    [storeGetters.chapterHealthReport]: state => state.chapterHealthReport,
    [storeGetters.getOverallChapterHealthScore]: state => state.healthScore,
};
